module.exports = __webpack_public_path__ + "img/process.36d9018f.svg";